
export default {
  data() {
    return {
      rotation: 0,
      size: 1,
    };
  },

  props: {
    image: String,
  },

  computed: {
    width() {
      return 100 * this.size;
    },
    height() {
      return 100 * this.size;
    },
  },

  methods: {
    rotate(direction) {
      if (direction === "left") {
        this.rotation = this.rotation - 90;
      } else {
        this.rotation = this.rotation + 90;
      }
    },

    zoom(mode) {
      if (mode === "in") {
        this.size += 0.2;
      } else if (mode === "out") {
        this.size -= 0.2;
      }
    },
  },
};
